export default "__VITE_ASSET__CUqXbvvY__"